<!-- <div class="table-responsive tableScroll mat-elevation-z8 margin-top-5" infinite-scroll [style.height.px]="tableHeight">
  <mat-table *ngIf="IsShow" [dataSource]="dataSource" matSort class="search-results Nestedtable">
    <ng-container matColumnDef="DateTime">
      <mat-header-cell class="width10" *matHeaderCellDef mat-sort-header>Date Time
      </mat-header-cell>
      <mat-cell class="width10" *matCellDef="let report">
        <div>{{report.Date | date:'dd/MM/yyyy HH:mm:ss'}}</div>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="ApperantPower">
      <mat-header-cell class="width10 justifyend" *matHeaderCellDef mat-sort-header>Apperant Power(kVA)
      </mat-header-cell>
      <mat-cell class="width10 justifyend" *matCellDef="let report">
        <div>{{report.ApperantPower.toFixed(2)}}</div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="ActivePower">
      <mat-header-cell class="width10 justifyend" *matHeaderCellDef mat-sort-header>Active Power(kW)
      </mat-header-cell>
      <mat-cell class="width10 justifyend" *matCellDef="let report">
        <div>{{report.ActivePower.toFixed(2)}}</div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="PowerFactor">
      <mat-header-cell class="width10 justifyend" *matHeaderCellDef mat-sort-header>Power Factor
      </mat-header-cell>
      <mat-cell class="width10 justifyend" *matCellDef="let report">
        <div>{{report.PowerFactor.toFixed(2)}}</div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="ActiveEnergy">
      <mat-header-cell class="width10 justifyend" *matHeaderCellDef mat-sort-header>Active Energy(kWh)
      </mat-header-cell>
      <mat-cell class="width10 justifyend" *matCellDef="let report">
        <div>{{report.ActiveEnergy.toFixed(2)}}</div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="ReactiveEnergy">
      <mat-header-cell class="width10 justifyend" *matHeaderCellDef mat-sort-header>Reactive Energy(kVARh)
      </mat-header-cell>
      <mat-cell class="width10 justifyend" *matCellDef="let report">
        <div>{{report.ReactiveEnergy.toFixed(2)}}</div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="ApperantEnergy">
      <mat-header-cell class="width10 justifyend pr-10" *matHeaderCellDef mat-sort-header>Apperant Energy(kVAh)
      </mat-header-cell>
      <mat-cell class="width10 justifyend pr-10" *matCellDef="let report">
        <div>{{report.ApperantEnergy.toFixed(2)}}</div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="MDI">
      <mat-header-cell class="width10 justifyend pr-10" *matHeaderCellDef mat-sort-header>MDI(kW)
      </mat-header-cell>
      <mat-cell class="width10 justifyend pr-10" *matCellDef="let report">
        <div>{{report.MDI.toFixed(2)}}</div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Voltage">
      <mat-header-cell class="width10 justifyend" *matHeaderCellDef mat-sort-header>Voltage(V)
      </mat-header-cell>
      <mat-cell class="width10 justifyend" *matCellDef="let report">
        <div>{{report.Voltage.toFixed(2)}}</div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Current">
      <mat-header-cell class="width10 justifyend pr-10" *matHeaderCellDef mat-sort-header>Current(A)
      </mat-header-cell>
      <mat-cell class="width10 justifyend pr-10" *matCellDef="let report">
        <div>{{report.Current.toFixed(2)}}</div>
      </mat-cell>
    </ng-container>
    <mat-header-row style="position:-webkit-sticky!important;position: sticky!important;top:0!important;"
      *matHeaderRowDef="displayedColumns ; sticky: true;"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns ;" style="cursor: pointer;"></mat-row>
  </mat-table>
  <div *ngIf="noDataMsg" class="main-errormsg paddingtop15 textcenter">{{noDataMsg}}</div>
</div> -->

<div class="table-responsive tableScroll mat-elevation-z8 margin-top-5" infinite-scroll [style.height.px]="tableHeight">
    <mat-table  *ngIf="IsShow" [dataSource]="dataSource" matSort class="search-results Nestedtable">
      <ng-container matColumnDef="DateTime">
        <mat-header-cell class="width10" *matHeaderCellDef mat-sort-header>Date Time
        </mat-header-cell>
        <mat-cell class="width10" *matCellDef="let report">
          <div>{{report.Date | date:'dd/MM/yyyy HH:mm:ss'}}</div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="ApperantPower">
        <mat-header-cell class="width10 justifyend head-th-end" *matHeaderCellDef mat-sort-header>Apperant Power(kVA)
        </mat-header-cell>
        <mat-cell class="width10  justifyend head-th-end" *matCellDef="let report">
          <div>{{report.ApperantPower.toFixed(2)}}</div>
        </mat-cell>
      </ng-container>
  
      <ng-container matColumnDef="ActivePower">
        <mat-header-cell class="width10 justifyend head-th-end" *matHeaderCellDef mat-sort-header>Active Power(kW)
        </mat-header-cell>
        <mat-cell class="width10  justifyend head-th-end" *matCellDef="let report">
          <div>{{report.ActivePower.toFixed(2)}}</div>
        </mat-cell>
      </ng-container>
  
      <ng-container matColumnDef="PowerFactor">
        <mat-header-cell class="width10 justifyend head-th-end" *matHeaderCellDef mat-sort-header>Power Factor
        </mat-header-cell>
        <mat-cell class="width10 justifyend head-th-end" *matCellDef="let report">
          <div>{{report.PowerFactor.toFixed(2)}}</div>
        </mat-cell>
      </ng-container>
  
      <ng-container matColumnDef="ActiveEnergy">
        <mat-header-cell class="width10 justifyend head-th-end" *matHeaderCellDef mat-sort-header>
    
          Active Energy(kWh)
          
          
        </mat-header-cell>
        <mat-cell class="width10 justifyend head-th-end" *matCellDef="let report">
          <div>{{report.ActiveEnergy.toFixed(2)}}</div>
        </mat-cell>
      </ng-container>
  
      <ng-container matColumnDef="ReactiveEnergy">
        <mat-header-cell class="width10 justifyend head-th-end1" style ="text-align: right;" *matHeaderCellDef mat-sort-header>Reactive Energy(kVARh)
        </mat-header-cell>
        <mat-cell class="width10 justifyend head-th-end" *matCellDef="let report">
          <div>{{report.ReactiveEnergy.toFixed(2)}}</div>
        </mat-cell>
      </ng-container>
  
      <ng-container matColumnDef="ApperantEnergy">
        <mat-header-cell class="width10 justifyend head-th-end pr-10" *matHeaderCellDef mat-sort-header>Apperant Power(kVA)
        </mat-header-cell>
        <mat-cell class="width10 justifyend head-th-end pr-10" *matCellDef="let report">
          <div>{{report.ApperantEnergy.toFixed(2)}}</div>
        </mat-cell>
      </ng-container>
  
      <ng-container matColumnDef="MDI">
        <mat-header-cell  class="width10 justifyend head-th-end pr-10" *matHeaderCellDef mat-sort-header>MDI(kW)
        </mat-header-cell>
        <mat-cell class="width10 justifyend head-th-end pr-10" *matCellDef="let report">
          <div>{{report.MDI.toFixed(2)}}</div>
        </mat-cell>
      </ng-container>
  
      <ng-container matColumnDef="Voltage">
        <mat-header-cell class="width10 justifyend head-th-end" *matHeaderCellDef mat-sort-header>
          Voltage(V)
        </mat-header-cell>
        <mat-cell class="width10 justifyend head-th-end" *matCellDef="let report">
          <div>{{report.Voltage.toFixed(2)}}</div>
        </mat-cell>
      </ng-container>
  
      <ng-container matColumnDef="Current">
        <mat-header-cell class="width10 justifyend head-th-end pr-10" *matHeaderCellDef mat-sort-header>Current(A)
        </mat-header-cell>
        <mat-cell class="width10 justifyend head-th-end pr-10" *matCellDef="let report">
          <div>{{report.Current.toFixed(2)}}</div>
        </mat-cell>
      </ng-container>
      <mat-header-row style="position:-webkit-sticky!important;position: sticky!important;top:0!important;"
        *matHeaderRowDef="displayedColumns ; sticky: true;"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns ;" style="cursor: pointer;"></mat-row>
    </mat-table>
    <div *ngIf="noDataMsg" class="main-errormsg paddingtop15 textcenter">{{noDataMsg}}</div>
  </div>